<template>
  <section
    class="w-4/6 pt-12 mx-auto text-secondary transition-colors duration-800 xl:w-11/12 sm:w-full"
    v-colors="{ primary: '#ffffff', secondary: '#000000' }"
  >
    <VehicleAdvancedFilter chipColor="purple" bgColor="white" class="text-purple">
      <Transition name="loader">
        <UiLoading v-if="pending"></UiLoading>
      </Transition>
    </VehicleAdvancedFilter>
  </section>
  <section
    class="w-4/6 px-4 pb-12 mx-auto text-secondary transition-colors duration-800 xl:w-11/12 sm:w-full"
    v-colors="{ primary: '#ffffff', secondary: '#000000' }"
  >
    <div
      v-if="filtered && filtered.length > 0"
      class="grid grid-cols-4 gap-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 mt-4"
    >
      <AppCarCard
        v-for="(car, index) in filtered"
        :class="{ 'scale-95 opacity-80': pending }"
        :style="{ order: index }"
        :car="car"
        :key="car.id"
        :isCardMd="true"
        :duration="bookingDuration"
        :discount="discount"
      >
      </AppCarCard>
      <VehicleFeatureCard
        v-if="filtered.length <= 5"
        :img="'/img/illustrations/pick_up.svg'"
        :title="t('car.feature-cards.booked-out')"
        :order="-1"
      />
      <VehicleFeatureCard
        v-if="filtered.length >= 6"
        :img="'/img/illustrations/km_limit.svg'"
        :title="t('car.feature-cards.km-limit')"
        :order="5"
      />
      <VehicleFeatureCard
        v-if="filtered.length >= 7"
        :img="'/img/illustrations/pick_up.svg'"
        :title="t('car.feature-cards.pickup')"
        :order="11"
      />
      <VehicleFeatureCard
        v-if="filtered.length >= 13"
        :img="'/img/illustrations/heart.svg'"
        :title="t('car.feature-cards.price')"
        :order="20"
      />
    </div>
    <div v-else-if="!pending" class="flex justify-center items-center min-h-64">
      <p class="text-center">{{ $t('home.filter.no-matches') }}</p>
    </div>
    <div v-if="filterError" class="flex justify-center items-center min-h-64">
      <p>{{ $t('home.filter.error-loading') }}</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Promotion, PromotionDiscount } from '@/types/backend';

definePageMeta({
  layout: 'edgeless',
});

const promo: Promotion = {
  name: 'September (less cheap)',
  type: 'general',
  frequency: 'yearly',
  vehicleType: 'L',
  discount: 0.5,
  months: [9],
};
// const store = useAuthStore();
// const { authToken } = storeToRefs(store);
// Authorization: authToken.value,

// const runtimeConfig = useRuntimeConfig();
// const backendBaseUrl = runtimeConfig.public.backendBaseUrl;
// const createPromotion = await $fetch<Promotion>(`${backendBaseUrl}/promotions`, {
//   method: 'POST',
//   headers: {
//     Authorization: 'b0dce299-ebe6-43ce-b9cb-075077450fc9',
//   },
//   body: promo,
// });

const { t } = useI18n();
const { frontendBaseUrl } = useRuntimeConfig().public;
useSeoMeta({
  title: t('seo-meta.cars.title'),
  ogTitle: t('seo-meta.cars.title'),
  description: t('seo-meta.cars.description'),
  ogDescription: t('seo-meta.cars.description'),
  ogImage: `${frontendBaseUrl}/img/og/thg-og-cars-web.jpg`,
});

const { getFiltered } = useVehicles();
const {
  startDate,
  endDate,
  vehicleTypes,
  advancedFilters,
  bookingDuration,
  getGlobalDiscount,
  allWheelFilter,
  fuelTypeFilter,
  transmissionTypeFilter,
} = useSearch();
let discount = await getGlobalDiscount();

watch([startDate, endDate], async () => {
  discount = await getGlobalDiscount();
});
const {
  data: filtered,
  error: filterError,
  pending,
} = await getFiltered({
  availableFrom: startDate,
  availableUntil: endDate,
  vehicleType: vehicleTypes,
  allWheel: allWheelFilter,
  fuelType: fuelTypeFilter,
  transmissionType: transmissionTypeFilter,
});
</script>
